import { useLocation, useParams } from 'react-router-dom'

import { Navigate } from '@lib/react-router-dom'

import { IB_DEFAULT_REGISTER_PAGE_PATH } from '@pages/IntroducingBroker/IntroducingBrokerRoutes'
import { IBQuestionnairePage } from '@pages/IntroducingBroker/SignUp/Questionnaire/IBQuestionnairePage'
import { useIntroducingBrokerById } from '@pages/IntroducingBroker/hooks/useIntroducingBrokerById'

import { useAccountReadContext } from '@context/AccountContextContext'

import { CommonPaths } from '@utils/path'

import { IBTestSubCategory } from '@model/TestSectionsDto'

interface IBQuestionnairePageGuardProps {
  isMultiTier?: boolean
}

export const IBQuestionnairePageGuard = ({ isMultiTier }: IBQuestionnairePageGuardProps) => {
  const { account } = useAccountReadContext()
  const location = useLocation()
  const { subCategoryId } = useParams<{ subCategoryId: IBTestSubCategory }>()
  const { data: introducingBroker } = useIntroducingBrokerById()

  if (!location.state?.fromSignUp) {
    if (
      isMultiTier &&
      !introducingBroker?.multiTierRegisteredAt &&
      subCategoryId === IBTestSubCategory.MultiTier
    ) {
      return <IBQuestionnairePage />
    }

    const path = account?.clientIntroducingBroker?.id
      ? CommonPaths.IntroducingBrokerDashboard
      : IB_DEFAULT_REGISTER_PAGE_PATH

    return <Navigate to={path} replace />
  }

  return <IBQuestionnairePage />
}
